import { cn } from "src/lib/utils";

export const MainLayout = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <article
      className={cn(
        "flex min-h-0 flex-grow flex-col gap-6 px-4 py-6 lg:px-0",
        className,
      )}
    >
      {children}
    </article>
  );
};

export default MainLayout;
